<template>
  <div>
    <Breadtabsheader />
    <div class="h-content w-content">
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
          <div class="filter-wrap">
<!--            <el-form-item label="考核季度">
              <el-select v-model="q.jidu" placeholder="请选择" clearable style="width:140px">
                <el-option label="Q1" value="Q1" />
                <el-option label="Q2" value="Q2" />
                <el-option label="Q3" value="Q3" />
                <el-option label="Q4" value="Q4" />
              </el-select>
            </el-form-item>-->

            <el-form-item label="经销商编码">
              <el-input v-model="q.customerId" placeholder="请输入经销商编码" clearable />
            </el-form-item>

            <el-form-item label="客户名称">
              <el-input v-model="q.customerName" placeholder="请输入客户名称" clearable />
            </el-form-item>

            <el-form-item label="产业">
              <brselect category="fl_26_cy_all" :v="q.lianQun" v-model="q.lianQun" :clearable="true" />
            </el-form-item>

            <el-form-item label="签约类型">
              <el-select v-model="q.signTargetType" placeholder="请选择" clearable style="width:140px">
                <el-option label="续签" :value="1" />
                <el-option label="新开" :value="3" />
              </el-select>
            </el-form-item>

            <!-- 领域/变更时间筛选已移除 -->
          </div>
        </el-form>

        <div class="h-tableB h-mrt30" style="text-align:right;">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon " @click="handleFilter">
              查询
            </el-button>
            <el-button class="h-btn h-formBtn" icon="h-el-icon h-el-icon-refresh" @click="reset">
              重置
            </el-button>
          </div>

        </div>

        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="customerId" label="经销商编码" width="140" :show-overflow-tooltip="true" />
          <el-table-column prop="customerName" label="客户名称" width="220" :show-overflow-tooltip="true" />
          <el-table-column prop="lianQun" label="产业" width="110" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ scope.row.lianQun | dictname('fl_26_cy_all') }}
            </template>
          </el-table-column>
          <el-table-column prop="signTargetType" label="签约类型" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ fmtSignTargetType(scope.row.signTargetType) }}
            </template>
          </el-table-column>

          <el-table-column label="Q1" align="center">
            <el-table-column prop="oldLevelQ1" label="变更前" width="95" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.oldLevelQ1 ? fmtLevel(scope.row.oldLevelQ1) : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="newLevelQ1" label="变更后" width="95" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.newLevelQ1 ? fmtLevel(scope.row.newLevelQ1) : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="typeQ1" label="调整后" width="95" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.typeQ1 ? fmtLevel(scope.row.typeQ1) : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="cunameQ1" label="调整人" width="100" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.cunameQ1 ? scope.row.cunameQ1 : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="ludateQ1" label="调整时间" width="120" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.ludateQ1 ? scope.row.ludateQ1 : '-' }}
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="Q2" align="center">
            <el-table-column prop="oldLevelQ2" label="变更前" width="95" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.oldLevelQ2 ? fmtLevel(scope.row.oldLevelQ2) : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="newLevelQ2" label="变更后" width="95" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.newLevelQ2 ? fmtLevel(scope.row.newLevelQ2) : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="typeQ2" label="调整后" width="95" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.typeQ2 ? fmtLevel(scope.row.typeQ2) : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="cunameQ2" label="调整人" width="100" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.cunameQ2 ? scope.row.cunameQ2 : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="ludateQ2" label="调整时间" width="120" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.ludateQ2 ? scope.row.ludateQ2 : '-' }}
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="Q3" align="center">
            <el-table-column prop="oldLevelQ3" label="变更前" width="95" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.oldLevelQ3 ? fmtLevel(scope.row.oldLevelQ3) : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="newLevelQ3" label="变更后" width="95" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.newLevelQ3 ? fmtLevel(scope.row.newLevelQ3) : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="typeQ3" label="调整后" width="95" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.typeQ3 ? fmtLevel(scope.row.typeQ3) : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="cunameQ3" label="调整人" width="100" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.cunameQ3 ? scope.row.cunameQ3 : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="ludateQ3" label="调整时间" width="120" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.ludateQ3 ? scope.row.ludateQ3 : '-' }}
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="Q4" align="center">
            <el-table-column prop="oldLevelQ4" label="变更前" width="95" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.oldLevelQ4 ? fmtLevel(scope.row.oldLevelQ4) : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="newLevelQ4" label="变更后" width="95" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.newLevelQ4 ? fmtLevel(scope.row.newLevelQ4) : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="typeQ4" label="调整后" width="95" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.typeQ4 ? fmtLevel(scope.row.typeQ4) : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="cunameQ4" label="调整人" width="100" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.cunameQ4 ? scope.row.cunameQ4 : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="ludateQ4" label="调整时间" width="120" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.ludateQ4 ? scope.row.ludateQ4 : '-' }}
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-download" @click="exportExcel">
              批量导出
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/utils/fetch'
import updownfile from '@/utils/updownfile'

export default {
  name: 'agentLevelChangeHistory',
  data() {
    return {
      q: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
        jidu: '',
        customerId: '',
        customerName: '',
        lianQun: '',
        signTargetType: null,
      },
      tableData: []
    }
  },
  created() {
    this.query()
  },
  methods: {
    handleFilter() {
      this.q.pageNo = 1
      this.query()
    },
    exportExcel() {
      updownfile.down('/api/swyl/v1/kaohe/agentLevelChangeHistory/exportExcel', this.q, 'post')
    },
    reset() {
      this.q = {
        pageNo: 1,
        pageSize: 10,
        total: 0,
        jidu: '',
        customerId: '',
        customerName: '',
        lianQun: '',
        signTargetType: null,
      }
      this.query()
    },
    query() {
      http({
        url: '/api/swyl/v1/kaohe/agentLevelChangeHistory/selectPage',
        method: 'post',
        params: this.q
      }).then(rd => {
        this.q.total = rd.total
        this.tableData = rd.records || []
      })
    },

    fmtLevel(level) {
      const map = { '00': '冻结', '01': '一级', '02': '二级', '03': '三级' }
      return map[String(level)] || level || ''
    },
    fmtSignTargetType(v) {
      const map = { 1: '续签', 3: '新开' }
      const key = v === null || v === undefined || v === '' ? null : Number(v)
      return key !== null && map[key] !== undefined ? map[key] : (v === null || v === undefined || v === '' ? '-' : String(v))
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

.filter-wrap ::v-deep .el-form-item {
  margin-right: 16px;
  margin-bottom: 12px;
}

.h-formBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 1366px) {
  .filter-wrap ::v-deep .el-form-item {
    margin-right: 12px;
  }
}
</style>

